const en = require.context('./', false, /\.(json)$/).keys();
export default en;
